import { setBearer } from "../../utils/constants";
import AdesaoModel from "../models/adesao";
import AdesaoValidationModel from "../models/adesaoValidation";
import CancelModel from "../models/cancel";
import ChangedPlanModel from "../models/changedPlan";
import ContractBasicInfoModel from "../models/contractBasic";
import PlansByContract from "../models/plansByContract";
import WitnessContractModel from "../models/witness";
import { createUser, endCancelRequest, enterpriseLoginRequest, fetchAdesao, fetchAdesaoFiltered, fetchContractsByNumberAndCpf, fetchEmails, fetchListOfCancelationRequest, fetchListOfCanceledPlans, fetchListOfChangedPlans, fetchPlansByContract, fetchUserData, resetPasword, setEmail } from "../provider/enterprise/api_enterprise";

export let cnpj: string;

export function setCnpj(value: string) {
    cnpj = value;
    localStorage.removeItem("cpf_cnpj")
    localStorage.setItem("cpf_cnpj", cnpj)
}

export function getCnpj(): string {
    return cnpj;
}


export async function enterpriseAuth(user: String, pswd: String) {
    const responseData = await enterpriseLoginRequest(user, pswd);

    setBearer(responseData.access_token);

    localStorage.setItem("access_token", responseData.access_token);
    localStorage.setItem("person_type", responseData.person_type);
    localStorage.setItem("id", responseData.id_associado);

    try {
        const response = await fetchUserData(user)

        localStorage.setItem("name", response.nome);
        localStorage.setItem("cep", response.cep);
        localStorage.setItem("street", response.logradouro);
        localStorage.setItem("number", response.numero);
        localStorage.setItem("city", response.cidade.nome_municipio);
        localStorage.setItem("cellphone", response.TELEFONE_EMP);
        localStorage.setItem("email", response.EMAIL_COB);

    } catch (error) {
        
    }
    

    return responseData
}

export async function getAdesaoList(enterpriseId: string): Promise<{ data: AdesaoValidationModel[] | null }> {
    try {
        const responseData = await fetchAdesao(enterpriseId); 

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        const data = responseData.map((item: any) => AdesaoValidationModel.fromApiResponse(item)); 

        return { data };

    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}

export async function getAdesaoListFiltered(enterpriseId: string, filter: string, startDate: string, endDate: string): Promise<{ data: AdesaoModel[] | null }> {
    try {
        
        const responseData = await fetchAdesaoFiltered(enterpriseId, filter, startDate, endDate); 

        
        console.log('Response Data:', responseData);

        
        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        
        const data = Array.isArray(responseData) 
            ? responseData.map((item: any) => AdesaoModel.fromApiResponse(item))
            : []; 
        
        return { data };

    } catch (error: any) {
        // Erro com a requisição ou mapeamento
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}


export async function getEmailsCNPJ(cnpj: string): Promise<string[]> {
    try {
        const responseData = await fetchEmails(cnpj); 

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        return responseData;

    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return [];
    }
}

export async function setAndSendEmail(email: string) {
    try {
        const responseData = await setEmail(email, cnpj); 
        
        if (responseData.statusCode && (responseData.statusCode !== 200 || responseData.statusCode !== 201)) {
            throw new Error(responseData.message || "Erro ao enviar email.");
        }
        
        console.log('Deu certo')
        
        return responseData;
        
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao enviar email.`);
        console.log(error.toString());
        return [];
    }
}

export async function changePassword(token: string, code: number, newPasword: string) {
    try {
        const responseData = await resetPasword(token, code, newPasword, localStorage.getItem("access_token")!); 

        if (responseData.statusCode && (responseData.statusCode !== 200 || responseData.statusCode !== 201)) {
            throw new Error(responseData.message || "Erro ao trocar senha.");
        }

        console.log('Deu certo')

        return responseData;

    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao trocar senha.`);
        console.log(error.toString());
        return [];
    }
}

export async function createNewUser(name: string, cpf: string, cep: string, street: string, number: string, comp: string, 
    neighborhood: string, cityId: number, ufId: number, email: string, cellphone: string, id_clube: string, dt_nascimento: string) {
    try {
        const responseData = await createUser(name, cpf, cep, street, number, comp, 
            neighborhood, cityId, ufId, email, cellphone, id_clube, dt_nascimento); 
        
        if (responseData.statusCode && (responseData.statusCode !== 200 && responseData.statusCode !== 201)) {
            throw new Error(responseData.message || "Erro ao criar cadastro.");
        }
        
        console.log('Deu certo')
        
        return responseData;
        
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao criar cadastro.`);
        console.log(error.toString());
        throw error;
    }
}

export async function getPlansByContract(): Promise<{ data: PlansByContract | null }> {
    try {
        const cnpj_cpf = localStorage.getItem("cpf_cnpj");
        const responseData = await fetchPlansByContract(cnpj_cpf!);

        console.log(responseData, "ESSE RETORNO AQUI")

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        const data = PlansByContract.fromApiResponse(responseData);

        return { data };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}

export async function getContractsByNumberAndCpf(contract_number: string, cpf: string): Promise<{ data: ContractBasicInfoModel | null }> {
    try {
        const responseData = await fetchContractsByNumberAndCpf(contract_number, cpf);
        

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        const data = ContractBasicInfoModel.fromSingleApiResponse(responseData);
        console.log(data, "Data model")

        return { data };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}

export async function getListOfCancelationRequest(contractId: string): Promise<{ data: CancelModel[] | null }> {
    try {
        const responseData = await fetchListOfCancelationRequest(contractId);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        const data = responseData.map((item: any) =>
            CancelModel.fromApiResponse(item)
          );

        return { data };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}

export async function destroyContractCancelRequest(
    cancelList: { id_contrato: number; motivo: number; observacao: string }[]
  ) {
    try {
      const responseData = await endCancelRequest(cancelList);
  
      if (
        responseData.statusCode &&
        responseData.statusCode !== 200 &&
        responseData.statusCode !== 201
      ) {
        throw new Error(responseData.message || "Erro ao cancelar contratos.");
      }
  
      console.log("Cancelamentos enviados com sucesso!");
  
      return responseData;
    } catch (error: any) {
      console.error(`Erro ao cancelar contratos: ${error?.message || error}`);
      return [];
    }
  }

  export async function getListOfCanceledPlans(contractId: string): Promise<{ data: WitnessContractModel[] | null }> {
    try {
      const responseData = await fetchListOfCanceledPlans(contractId);
  
      if (responseData.statusCode && responseData.statusCode !== 200) {
        throw new Error(responseData.message || "Erro ao buscar os dados.");
      }
  
      if (responseData.planos && Array.isArray(responseData.planos)) {
        const cnpjAssociado = responseData.convenio?.associado?.cnpj || "";
  
        const data = responseData.planos.map((item: any) =>
          WitnessContractModel.fromApiResponse({
            ...item,
            cnpjAssociado: cnpjAssociado
          })
        );
        return { data };
      }
  
      throw new Error("Formato de resposta inválido.");
    } catch (error: any) {
      console.error(`Erro (${error?.response?.status || "desconhecido"}) ao buscar os dados`);
      console.log(error.toString());
      return { data: null };
    }
  }

export async function getListOfChangedPlans(contractId: string): Promise<{ data: ChangedPlanModel[] | null }> {
    try {
        const responseData = await fetchListOfChangedPlans(contractId);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        if (Array.isArray(responseData)) {
            const data = responseData.map((item: any) =>
                ChangedPlanModel.fromApiResponse(item)
            );
            return { data };
        }

        throw new Error("Formato de resposta inválido.");
    } catch (error: any) {
        console.error(`Erro (${error?.response?.status || "desconhecido"}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}